import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserData } from '@AppRoot/shared/models/user.interface';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @Output() close = new EventEmitter<void>();
  userImage = 'assets/images/user.png';

  isLoggedIn = false;
  private subscription: Subscription;
  dropdownOpen = false;
  userData: UserData | null = null;

  constructor(private _globalutilityService: GlobalUtilityService) {
    this.subscription = this._globalutilityService
      .getLoginStatus()
      .subscribe((status) => {
        this.isLoggedIn = status;
      });
    this.subscription.add(
      this._globalutilityService.getUserData().subscribe((data) => {
        this.userData = data;
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeSidebar() {
    this.close.emit();
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  openFeedbackModal() {
    this.close.emit();
    this._globalutilityService.setFeedbackFormStatus(true);
  }

  logout() {
    this._globalutilityService.logOut();
    location.reload();
    this._globalutilityService.setLoginStatus(false);
  }

  navigate(route?: string) {
      this._globalutilityService.navigateToPath(`/${route}`);
  }
}
